export const BodyMassIndexValue = {
  LOW: 25,
  MID: 30,
  MID_HIGH: '30-35',
  HIGHT: 35,
} as const;
